import { ChangeDetectionStrategy, Component, computed, input, type InputSignal, type Signal } from '@angular/core';
import { UiMetaChipVariant } from '../../types/ui-meta-chip-variant.type';

@Component({
  selector: 'ui-meta-chip',
  imports: [],
  templateUrl: './ui-meta-chip.component.html',
  styleUrl: './ui-meta-chip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiMetaChipComponent {
  public readonly variant: InputSignal<UiMetaChipVariant> = input<UiMetaChipVariant>('neutral');

  protected readonly isNeutral: Signal<boolean> = computed((): boolean => this.variant() === 'neutral');
  protected readonly isOk: Signal<boolean> = computed((): boolean => this.variant() === 'ok');
  protected readonly isMissing: Signal<boolean> = computed((): boolean => this.variant() === 'missing');
  protected readonly isAi: Signal<boolean> = computed((): boolean => this.variant() === 'ai');
}
